import React from 'react';
import RBanner1 from "../../../assets/images/banner/r-banner1.gif";

const RightMidAds = () => {

    return (
        <div style={{ height: "auto" }}>
            <img style={{ height: "auto", width: "100%" }} id="randomImage" src={RBanner1} alt="randomImage" />
        </div>
    );
};

export default RightMidAds;
